import './A.scss';

import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class A extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        href: PropTypes.string,
        noLinkClass: PropTypes.bool,
        target: PropTypes.string,
        to: PropTypes.string
    };

    render() {
        let { className, noLinkClass, ...otherProps} = this.props;

        if(this.props.to != null) {
            return (
                <Link {...otherProps} className={classNames(className, {'c-link': noLinkClass !== true})}>
                    {this.props.children}
                </Link>
            );
        } else {
            return (
                <a {...otherProps} className={`c-link ${className || ''}`}>
                    {this.props.children}
                </a>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/A/index.js